import { sgtinVisualPart } from "@/helpers/sgtin-ui-friendly-tag";
import * as Models from "@gigalot/data-models";

type AnimalWithWithdrawal = Models.Animal & { withdrawalDays?: number };

export interface TagUiOptions {
  includeProducer?: boolean;
  includeOriginCodes?: boolean;
}

export function tagUi(tag: Models.Tag, animals: AnimalWithWithdrawal[], options: TagUiOptions = {}): { tag: string, withdrawal?: string } {
  const { includeProducer = true, includeOriginCodes = true } = options;
  let ret: { tag: string, withdrawal?: string } = { tag: "", withdrawal: undefined }
  try {
    ret.tag = sgtinVisualPart(tag.sgtin)
  } catch (err) {
    console.error(err)
    return { tag: "" }
  }

  const animal = animals.find((a) => a.sgtin === tag.sgtin);
  if (!animal) return ret;

  if (animal.owner) ret.tag += ` - ${animal.owner}`;
  //TODO: make the (withdrawal days) red and bold
  if (animal.withdrawalDays !== undefined && animal.withdrawalDays > 0) ret.withdrawal = `(${animal.withdrawalDays} days withdrawal)`;
  if (includeProducer && animal.producer) ret.tag += ` - ${animal.producer}`;

  if (includeOriginCodes) {
    if (animal.allflex?.startsWith("LA.516")) ret.tag += ` - NAM`;
    if (animal.allflex?.startsWith("LA.072")) ret.tag += ` - BWA`;
  }

  return ret;
}
